import styled from 'styled-components';
import {TiPencil} from 'react-icons/ti';

export const Tipencil = styled(TiPencil)`
  color: #08ECD1;
`